import React, { useState, useRef } from 'react';
import imageCompression from 'browser-image-compression';
import iconeAdicionarFoto from '../icone_adicionar_foto.png';
import { auth, db, storage } from '../services/firebase';
import { doc, updateDoc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import emailjs from '@emailjs/browser';

const PAISES = [
  { nome: 'Brasil',       bandeira: '🇧🇷', codigo: '+55',  digitos: 11, mascara: '(##) #####-####' },
  { nome: 'Portugal',     bandeira: '🇵🇹', codigo: '+351', digitos: 9,  mascara: '### ### ###' },
  { nome: 'EUA / Canadá', bandeira: '🇺🇸', codigo: '+1',   digitos: 10, mascara: '(###) ###-####' },
  { nome: 'Argentina',    bandeira: '🇦🇷', codigo: '+54',  digitos: 10, mascara: '## ####-####' },
  { nome: 'Uruguai',      bandeira: '🇺🇾', codigo: '+598', digitos: 8,  mascara: '#### ####' },
  { nome: 'Chile',        bandeira: '🇨🇱', codigo: '+56',  digitos: 9,  mascara: '# #### ####' },
];

function aplicarMascara(valor, mascara) {
  let i = 0;
  return mascara.replace(/#/g, () => valor[i++] || '');
}

function parseTelefoneInicial(str) {
  if (!str) return { pais: PAISES[0], digitos: '' };
  for (const p of PAISES) {
    if (str.startsWith(p.codigo)) {
      const raw = str.slice(p.codigo.length).replace(/\D/g, '').slice(0, p.digitos);
      return { pais: p, digitos: raw };
    }
  }
  const raw = str.replace(/\D/g, '').slice(0, PAISES[0].digitos);
  return { pais: PAISES[0], digitos: raw };
}

function parseEnderecoInicial(end) {
  if (!end) return { rua: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '', cep: '' };
  if (typeof end === 'object' && end !== null) {
    return {
      rua: end.rua || '', numero: end.numero || '', complemento: end.complemento || '',
      bairro: end.bairro || '', cidade: end.cidade || '', estado: end.estado || '', cep: end.cep || '',
    };
  }
  return { rua: typeof end === 'string' ? end : '', numero: '', complemento: '', bairro: '', cidade: '', estado: '', cep: '' };
}

const duracoes = ['15 min','30 min','45 min','60 min','75 min','90 min','120 min'];
const DIAS_SEMANA = ['Seg','Ter','Qua','Qui','Sex','Sáb','Dom'];

// 24 horas disponíveis
const HORARIOS_CONFIG = (() => {
  const r = [];
  for (let h = 0; h <= 23; h++) {
    r.push(`${String(h).padStart(2,'0')}:00`);
    r.push(`${String(h).padStart(2,'0')}:30`);
  }
  return r;
})();

const BARBEIRO_PADRAO = {
  nome: '', foto: '',
  horariosPorDia: {
    'Seg': [{ inicio: '09:00', fim: '13:00' }, { inicio: '14:00', fim: '19:00' }],
    'Ter': [{ inicio: '09:00', fim: '13:00' }, { inicio: '14:00', fim: '19:00' }],
    'Qua': [{ inicio: '09:00', fim: '13:00' }, { inicio: '14:00', fim: '19:00' }],
    'Qui': [{ inicio: '09:00', fim: '13:00' }, { inicio: '14:00', fim: '19:00' }],
    'Sex': [{ inicio: '09:00', fim: '13:00' }, { inicio: '14:00', fim: '19:00' }],
    'Sáb': [{ inicio: '09:00', fim: '13:00' }],
  },
};

function migrarParaHorariosPorDia(b) {
  if (b.horariosPorDia && Object.keys(b.horariosPorDia).length > 0) return b;
  const horariosPorDia = {};
  (b.diasTrabalho || []).forEach(dia => {
    horariosPorDia[dia] = [{ inicio: b.horaInicio || '09:00', fim: b.horaFim || '19:00' }];
  });
  return { ...b, horariosPorDia };
}

function horaParaMinutos(h) {
  const [hh, mm] = h.split(':').map(Number);
  return hh * 60 + mm;
}

function validarTurnos(periodos) {
  if (!periodos || periodos.length === 0) return null;
  for (let i = 0; i < periodos.length; i++) {
    const p = periodos[i];
    if (horaParaMinutos(p.fim) <= horaParaMinutos(p.inicio)) {
      return `Turno ${i + 1}: o horário de término deve ser após o início`;
    }
  }
  if (periodos.length === 2) {
    if (horaParaMinutos(periodos[1].inicio) <= horaParaMinutos(periodos[0].fim)) {
      return 'O Turno 2 deve começar após o término do Turno 1';
    }
  }
  return null;
}

async function uploadFoto(arquivo, caminho) {
  const options = { maxSizeMB: 0.5, maxWidthOrHeight: 800, useWebWorker: true };
  const comprimido = await imageCompression(arquivo, options);
  const storageRef = ref(storage, caminho);
  await uploadBytes(storageRef, comprimido);
  return await getDownloadURL(storageRef);
}

function FotoAvatar({ fotoUrl, onArquivo, tamanho = 80, redondo = false }) {
  const inputArquivoRef = useRef(null);
  const inputCameraRef = useRef(null);
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <>
      {menuAberto && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 999
        }} onClick={() => setMenuAberto(false)}>
          <div style={{
            width: '100%', maxWidth: '480px', backgroundColor: '#181818',
            borderRadius: '16px 16px 0 0', padding: '24px', border: '0.5px solid #252525'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ width: '40px', height: '4px', backgroundColor: '#333', borderRadius: '2px', margin: '0 auto 20px' }} />
            <button onClick={() => { setMenuAberto(false); setTimeout(() => inputArquivoRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', marginBottom: '10px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📁 Escolher da galeria
            </button>
            <button onClick={() => { setMenuAberto(false); setTimeout(() => inputCameraRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📸 Tirar foto
            </button>
          </div>
        </div>
      )}
      <input ref={inputArquivoRef} type="file" accept="image/*" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && onArquivo(e.target.files[0])} />
      <input ref={inputCameraRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && onArquivo(e.target.files[0])} />
      <div onClick={() => setMenuAberto(true)} style={{ position: 'relative', cursor: 'pointer', width: tamanho, height: tamanho }}>
        <div style={{
          width: tamanho, height: tamanho,
          borderRadius: redondo ? '50%' : '10px',
          backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a',
          overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          {fotoUrl
            ? <img src={fotoUrl} alt="foto" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => { e.target.style.display = 'none'; }} />
            : <img src={iconeAdicionarFoto} alt="adicionar" style={{ width: tamanho * 0.55, height: tamanho * 0.55, opacity: 0.35, filter: 'invert(1)' }} />
          }
        </div>
        <div style={{
          position: 'absolute', bottom: -4, right: -4,
          width: '20px', height: '20px', borderRadius: '50%',
          backgroundColor: '#2d4a2d', border: '2px solid #0a0a0a',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px'
        }}>✏️</div>
      </div>
    </>
  );
}

function PerfilBarbearia({ barbearia, onAtualizar }) {
  const [passo, setPasso] = useState(1);
  const TOTAL_PASSOS = 4;

  // Step 1 — Dados básicos
  const [nome, setNome] = useState(barbearia?.nome || '');
  const _telInicial = parseTelefoneInicial(barbearia?.telefone || '');
  const [telefonePais, setTelefonePais] = useState(_telInicial.pais);
  const [telefoneDigitos, setTelefoneDigitos] = useState(_telInicial.digitos);
  const [mostrarPaises, setMostrarPaises] = useState(false);
  const _endInicial = parseEnderecoInicial(barbearia?.endereco);
  const [rua, setRua] = useState(_endInicial.rua);
  const [numero, setNumero] = useState(_endInicial.numero);
  const [complemento, setComplemento] = useState(_endInicial.complemento);
  const [bairro, setBairro] = useState(_endInicial.bairro);
  const [cidade, setCidade] = useState(_endInicial.cidade);
  const [estado, setEstado] = useState(_endInicial.estado);
  const [cep, setCep] = useState(_endInicial.cep);
  const [cepCarregando, setCepCarregando] = useState(false);
  const [descricao, setDescricao] = useState(barbearia?.descricao || '');
  const [fotoUrl, setFotoUrl] = useState(barbearia?.foto || '');

  // Step 2 — Barbeiros
  const [barbeiros, setBarbeiros] = useState(
    (barbearia?.barbeiros || [{ ...BARBEIRO_PADRAO, horariosPorDia: JSON.parse(JSON.stringify(BARBEIRO_PADRAO.horariosPorDia)) }]).map(b => {
      const migrado = migrarParaHorariosPorDia(b);
      return { ...BARBEIRO_PADRAO, ...migrado };
    })
  );
  const [diaAtivoPorBarbeiro, setDiaAtivoPorBarbeiro] = useState({});

  // Step 3 — Serviços
  const [servicos, setServicos] = useState(
    barbearia?.servicos?.length > 0
      ? barbearia.servicos
      : [{ nome: '', preco: '', duracao: '30 min' }]
  );

  // Step 4 — Fotos recinto
  const [fotosRecinto, setFotosRecinto] = useState(barbearia?.fotosRecinto || []);
  const inputRecintoRef = useRef(null);
  const inputRecintoCamRef = useRef(null);
  const [menuRecintoAberto, setMenuRecintoAberto] = useState(false);

  const [slug, setSlug] = useState(barbearia?.slug || '');
  const [slugErro, setSlugErro] = useState('');

  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');

  const inputStyle = {
    width: '100%', padding: '12px', borderRadius: '10px',
    border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
    color: '#e8e8e8', fontSize: '14px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Arial, sans-serif'
  };
  const labelStyle = {
    fontSize: '10px', color: '#9c9c9c', letterSpacing: '1px',
    textTransform: 'uppercase', display: 'block', marginBottom: '5px'
  };

  // ── Preço em R$ formatado ──
  function handlePrecoChange(i, raw) {
    let v = raw.replace(/[^0-9,]/g, '');
    const parts = v.split(',');
    if (parts.length > 2) v = parts[0] + ',' + parts.slice(1).join('');
    if (parts[1] !== undefined) v = parts[0] + ',' + parts[1].slice(0, 2);
    if (v && !v.startsWith('0,')) v = v.replace(/^0+/, '') || '';
    const n = [...servicos]; n[i] = { ...n[i], preco: v ? `R$ ${v}` : '' }; setServicos(n);
  }

  // ── CEP: busca automática via ViaCEP ──
  async function buscarCep(valor) {
    const digits = valor.replace(/\D/g, '').slice(0, 8);
    const formatado = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    setCep(formatado);
    if (digits.length !== 8) return;
    setCepCarregando(true);
    try {
      const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      const data = await resp.json();
      if (!data.erro) {
        setRua(data.logradouro || '');
        setBairro(data.bairro || '');
        setCidade(data.localidade || '');
        setEstado(data.uf || '');
      }
    } catch (e) { console.error('Erro CEP:', e); }
    setCepCarregando(false);
  }

  // ── Barbeiro helpers ──
  async function handleNovaFotoPrincipal(arquivo) {
    const uid = auth.currentUser?.uid;
    const url = await uploadFoto(arquivo, `barbearias/${uid}/foto_barbearia`);
    setFotoUrl(url);
  }

  async function handleNovaFotoRecinto(arquivo) {
    const uid = auth.currentUser?.uid;
    const idx = fotosRecinto.length;
    const url = await uploadFoto(arquivo, `barbearias/${uid}/recinto_${idx}_${Date.now()}`);
    setFotosRecinto(prev => [...prev, url]);
    setMenuRecintoAberto(false);
  }

  async function handleFotoBarbeiro(arquivo, idx) {
    const uid = auth.currentUser?.uid;
    const url = await uploadFoto(arquivo, `barbearias/${uid}/barbeiro_${idx}_${Date.now()}`);
    const novos = [...barbeiros];
    novos[idx] = { ...novos[idx], foto: url };
    setBarbeiros(novos);
  }

  function getDiaEditando(idx) {
    const hp = barbeiros[idx]?.horariosPorDia || {};
    const diasAtivos = DIAS_SEMANA.filter(d => hp[d]?.length > 0);
    return diaAtivoPorBarbeiro[idx] || diasAtivos[0] || null;
  }

  function selecionarDiaBarb(idx, dia) {
    const hp = barbeiros[idx]?.horariosPorDia || {};
    if (!hp[dia]) {
      const novos = [...barbeiros];
      novos[idx] = { ...novos[idx], horariosPorDia: { ...hp, [dia]: [{ inicio: '09:00', fim: '13:00' }] } };
      setBarbeiros(novos);
    }
    setDiaAtivoPorBarbeiro(prev => ({ ...prev, [idx]: dia }));
  }

  function removerDiaBarb(idx, dia) {
    const novos = [...barbeiros];
    const hp = { ...(novos[idx].horariosPorDia || {}) };
    delete hp[dia];
    novos[idx] = { ...novos[idx], horariosPorDia: hp };
    setBarbeiros(novos);
    const diasRestantes = DIAS_SEMANA.filter(d => d !== dia && hp[d]?.length > 0);
    setDiaAtivoPorBarbeiro(prev => ({ ...prev, [idx]: diasRestantes[0] || null }));
  }

  function adicionarTurno2(idx) {
    const dia = getDiaEditando(idx);
    if (!dia) return;
    const novos = [...barbeiros];
    const hp = { ...(novos[idx].horariosPorDia || {}) };
    if (hp[dia]?.length >= 2) return; // já tem 2 turnos
    const turno1Fim = hp[dia]?.[0]?.fim || '13:00';
    // Sugerir início do turno 2 como 1h após fim do turno 1
    const [fh, fm] = turno1Fim.split(':').map(Number);
    const novoInicioMins = fh * 60 + fm + 60;
    const novoInicioH = Math.floor(novoInicioMins / 60) % 24;
    const novoInicioM = novoInicioMins % 60;
    const novoInicio = `${String(novoInicioH).padStart(2,'0')}:${String(novoInicioM).padStart(2,'0')}`;
    // Fim 6h após o início sugerido
    const novoFimMins = novoInicioMins + 360;
    const novoFimH = Math.floor(novoFimMins / 60) % 24;
    const novoFimM = novoFimMins % 60;
    const novoFim = `${String(novoFimH).padStart(2,'0')}:${String(novoFimM).padStart(2,'0')}`;
    hp[dia] = [...(hp[dia] || []), { inicio: novoInicio, fim: novoFim }];
    novos[idx] = { ...novos[idx], horariosPorDia: hp };
    setBarbeiros(novos);
  }

  function removerTurno2(idx) {
    const dia = getDiaEditando(idx);
    if (!dia) return;
    const novos = [...barbeiros];
    const hp = { ...(novos[idx].horariosPorDia || {}) };
    hp[dia] = [hp[dia][0]]; // keep only turno 1
    novos[idx] = { ...novos[idx], horariosPorDia: hp };
    setBarbeiros(novos);
  }

  function updatePeriodoBarb(idx, periodoIdx, campo, valor) {
    const dia = getDiaEditando(idx);
    if (!dia) return;
    const novos = [...barbeiros];
    const hp = { ...(novos[idx].horariosPorDia || {}) };
    hp[dia] = hp[dia].map((p, i) => i === periodoIdx ? { ...p, [campo]: valor } : p);
    novos[idx] = { ...novos[idx], horariosPorDia: hp };
    setBarbeiros(novos);
  }

  // ── Validação por passo ──
  function validarPasso(p) {
    if (p === 1) {
      if (!nome.trim()) return 'O nome da barbearia é obrigatório';
      if (telefoneDigitos.length !== telefonePais.digitos) return `Digite um telefone válido (${telefonePais.digitos} dígitos)`;
      if (!rua.trim() || !numero.trim() || !bairro.trim() || !cidade.trim() || !estado.trim()) return 'Preencha todos os campos obrigatórios do endereço';
    }
    if (p === 2) {
      for (let i = 0; i < barbeiros.length; i++) {
        const b = barbeiros[i];
        if (!b.nome?.trim()) return `Barbeiro ${i + 1}: informe o nome`;
        for (const dia of DIAS_SEMANA) {
          const periodos = b.horariosPorDia?.[dia];
          if (!periodos || periodos.length === 0) continue;
          const erroTurno = validarTurnos(periodos);
          if (erroTurno) return `Barbeiro ${i + 1} — ${dia}: ${erroTurno}`;
        }
      }
    }
    return null;
  }

  function avancar() {
    const erroValidacao = validarPasso(passo);
    if (erroValidacao) { setErro(erroValidacao); return; }
    setErro('');
    if (passo < TOTAL_PASSOS) {
      setPasso(p => p + 1);
    } else {
      salvar();
    }
  }

  function voltar() {
    setErro('');
    setPasso(p => p - 1);
  }

  async function geocodificar(enderecoStr) {
    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(enderecoStr)}&limit=1`;
      const resp = await fetch(url, { headers: { 'Accept-Language': 'pt-BR', 'User-Agent': 'BladeApp/1.0' } });
      const data = await resp.json();
      if (data.length > 0) return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    } catch (_) {}
    return null;
  }

  async function salvar() {
    setSalvando(true);
    setErro('');
    setSucesso('');
    setSlugErro('');

    // Valida slug se preenchido
    const slugLimpo = slug.trim().toLowerCase().replace(/\s+/g, '-');
    if (slugLimpo && !/^[a-z0-9][a-z0-9-]{1,38}[a-z0-9]$/.test(slugLimpo)) {
      setSlugErro('Use apenas letras, números e hífen. Mínimo 3 caracteres.');
      setSalvando(false);
      return;
    }

    try {
      const uid = auth.currentUser?.uid;

      // Verifica unicidade do slug
      if (slugLimpo && slugLimpo !== barbearia?.slug) {
        const qSlug = query(collection(db, 'barbearias'), where('slug', '==', slugLimpo));
        const slugSnaps = await getDocs(qSlug);
        if (!slugSnaps.empty) {
          setSlugErro('Esse endereço já está em uso. Escolha outro.');
          setSalvando(false);
          return;
        }
      }
      const telefoneCompleto = telefonePais.codigo + telefoneDigitos;
      const enderecoCompleto = `${rua}, ${numero}${complemento ? ` ${complemento}` : ''} — ${bairro}, ${cidade} - ${estado}${cep ? `, CEP ${cep}` : ''}`;
      const coords = await geocodificar(`${rua}, ${numero}, ${bairro}, ${cidade}, ${estado}, Brasil`);
      const dados = {
        nome, telefone: telefoneCompleto,
        endereco: { rua, numero, complemento, bairro, cidade, estado, cep, completo: enderecoCompleto },
        descricao, foto: fotoUrl, fotosRecinto,
        barbeiros: barbeiros.filter(b => b.nome?.trim()),
        servicos: servicos.filter(s => s.nome?.trim() && s.preco?.trim()),
        ...(slugLimpo ? { slug: slugLimpo } : {}),
        ...(coords ? { lat: coords.lat, lng: coords.lng } : {}),
      };
      await updateDoc(doc(db, 'barbearias', uid), dados);

      // Envia e-mail de aprovação se ainda não foi enviado e campos obrigatórios preenchidos
      const snap = await getDoc(doc(db, 'barbearias', uid));
      const snapData = snap.data() || {};
      const serviceId  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
      const publicKey  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
      const emailjsOk  = serviceId && !serviceId.includes('seu_') && templateId && !templateId.includes('seu_') && publicKey && !publicKey.includes('sua_');

      if (!snapData.emailAprovacaoEnviado && nome.trim() && rua.trim() && telefoneDigitos && emailjsOk) {
        try {
          const nomeResp = auth.currentUser?.displayName || nome;
          await emailjs.send(serviceId, templateId, {
            nome_responsavel: nomeResp,
            nome_barbearia: nome.trim(),
            telefone: telefoneCompleto,
            endereco: enderecoCompleto,
            link_aprovacao: `https://blade.app.br/admin/aprovar?id=${uid}`,
            to_email: 'blade.app.conta@gmail.com',
          }, publicKey);
          await updateDoc(doc(db, 'barbearias', uid), { emailAprovacaoEnviado: true });
        } catch (emailErr) {
          console.error('Erro ao enviar e-mail de aprovação:', emailErr);
        }
      } else if (!emailjsOk) {
        console.warn('⚠️  EmailJS não configurado — preencha as variáveis no .env e no Vercel.');
      }

      setSucesso('Perfil salvo com sucesso!');
      onAtualizar && onAtualizar(dados);
    } catch (e) {
      setErro('Erro ao salvar. Tente novamente.');
      console.error(e);
    }
    setSalvando(false);
  }

  const passoLabels = ['Dados', 'Barbeiros', 'Serviços', 'Fotos'];

  return (
    <div style={{ padding: '0 20px 32px' }}>

      {/* Menu foto recinto */}
      {menuRecintoAberto && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 999
        }} onClick={() => setMenuRecintoAberto(false)}>
          <div style={{
            width: '100%', maxWidth: '480px', backgroundColor: '#181818',
            borderRadius: '16px 16px 0 0', padding: '24px', border: '0.5px solid #252525'
          }} onClick={e => e.stopPropagation()}>
            <div style={{ width: '40px', height: '4px', backgroundColor: '#333', borderRadius: '2px', margin: '0 auto 20px' }} />
            <button onClick={() => { setTimeout(() => inputRecintoRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', marginBottom: '10px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📁 Escolher da galeria
            </button>
            <button onClick={() => { setTimeout(() => inputRecintoCamRef.current?.click(), 100); }}
              style={{ width: '100%', padding: '14px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '12px', color: '#e8e8e8', fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif' }}>
              📸 Tirar foto
            </button>
          </div>
        </div>
      )}
      <input ref={inputRecintoRef} type="file" accept="image/*" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && handleNovaFotoRecinto(e.target.files[0])} />
      <input ref={inputRecintoCamRef} type="file" accept="image/*" capture="environment" style={{ display: 'none' }}
        onChange={e => e.target.files[0] && handleNovaFotoRecinto(e.target.files[0])} />

      {/* Indicador de progresso */}
      <div style={{ marginBottom: '24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
          {passoLabels.map((label, i) => (
            <div key={i} onClick={() => { if (i + 1 < passo) { setErro(''); setPasso(i + 1); } }}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, cursor: i + 1 < passo ? 'pointer' : 'default' }}>
              <div style={{
                width: '28px', height: '28px', borderRadius: '50%',
                backgroundColor: passo > i + 1 ? '#2d4a2d' : passo === i + 1 ? '#3d6b3d' : '#1a1a1a',
                border: `1.5px solid ${passo >= i + 1 ? '#3d6b3d' : '#252525'}`,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '11px', color: passo >= i + 1 ? '#7bc47b' : '#555',
                fontWeight: '700', marginBottom: '4px', transition: 'all 0.2s'
              }}>
                {passo > i + 1 ? '✓' : i + 1}
              </div>
              <span style={{ fontSize: '9px', color: passo >= i + 1 ? '#7bc47b' : '#444', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                {label}
              </span>
            </div>
          ))}
        </div>
        {/* Barra de progresso */}
        <div style={{ height: '2px', backgroundColor: '#1a1a1a', borderRadius: '1px', marginTop: '4px' }}>
          <div style={{ height: '100%', backgroundColor: '#2d4a2d', borderRadius: '1px', width: `${((passo - 1) / (TOTAL_PASSOS - 1)) * 100}%`, transition: 'width 0.3s' }} />
        </div>
      </div>

      {/* ── PASSO 1: Dados ── */}
      {passo === 1 && (
        <>
          <div style={{ marginBottom: '16px' }}>
            <label style={labelStyle}>Foto principal da barbearia</label>
            <FotoAvatar fotoUrl={fotoUrl} onArquivo={handleNovaFotoPrincipal} tamanho={88} redondo={false} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={{ ...labelStyle, color: '#aeaeae' }}>Nome da barbearia <span style={{ color: '#e24b4a' }}>*</span></label>
            <input type="text" value={nome} onChange={e => setNome(e.target.value)} style={inputStyle} placeholder="Ex: Barbearia do João" />
          </div>
          {/* Link personalizado */}
          <div style={{ marginBottom: '16px' }}>
            <label style={{ ...labelStyle, color: '#aeaeae' }}>Link da barbearia</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0', border: '0.5px solid #2a2a2a', borderRadius: '10px', overflow: 'hidden', backgroundColor: '#1a1a1a' }}>
              <span style={{ padding: '12px 10px 12px 12px', fontSize: '13px', color: '#8f8f8f', whiteSpace: 'nowrap', borderRight: '0.5px solid #2a2a2a', flexShrink: 0 }}>blade.app.br/</span>
              <input
                type="text"
                value={slug}
                onChange={e => {
                  setSlugErro('');
                  setSlug(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''));
                }}
                style={{ ...inputStyle, border: 'none', borderRadius: 0, backgroundColor: 'transparent', flex: 1, minWidth: 0 }}
                placeholder="minha-barbearia"
                maxLength={40}
              />
            </div>
            {slugErro && <div style={{ fontSize: '11px', color: '#e05555', marginTop: '5px' }}>{slugErro}</div>}
            {slug && !slugErro && (
              <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '5px' }}>
                Seu link: <span style={{ color: '#7bc47b' }}>blade.app.br/{slug}</span>
              </div>
            )}
            {!slug && (
              <div style={{ fontSize: '11px', color: '#7d7d7d', marginTop: '5px' }}>
                Opcional · Use para compartilhar na bio do Instagram
              </div>
            )}
          </div>
          {/* Telefone com DDI */}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ ...labelStyle, color: '#aeaeae' }}>Telefone / WhatsApp <span style={{ color: '#e24b4a' }}>*</span></label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <button type="button" onClick={() => setMostrarPaises(!mostrarPaises)}
                  style={{ height: '46px', padding: '0 12px', backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '10px', color: '#e8e8e8', cursor: 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap', fontFamily: 'Arial, sans-serif' }}>
                  <span>{telefonePais.bandeira}</span>
                  <span>{telefonePais.codigo}</span>
                  <span style={{ fontSize: '9px', color: '#8f8f8f' }}>▼</span>
                </button>
                {mostrarPaises && (
                  <div style={{ position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 200, backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a', borderRadius: '10px', overflow: 'hidden', minWidth: '200px', boxShadow: '0 8px 24px rgba(0,0,0,0.6)' }}>
                    {PAISES.map(p => (
                      <div key={p.codigo} onClick={() => { setTelefonePais(p); setTelefoneDigitos(''); setMostrarPaises(false); }}
                        style={{ padding: '11px 14px', cursor: 'pointer', fontSize: '13px', color: telefonePais.codigo === p.codigo ? '#7bc47b' : '#ccc', backgroundColor: telefonePais.codigo === p.codigo ? '#1e2e1e' : 'transparent', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <span>{p.bandeira}</span>
                        <span style={{ flex: 1 }}>{p.nome}</span>
                        <span style={{ color: '#8f8f8f', fontSize: '12px' }}>{p.codigo}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <input type="tel" inputMode="numeric"
                placeholder={telefonePais.mascara.replace(/#/g, '0')}
                value={aplicarMascara(telefoneDigitos, telefonePais.mascara)}
                onChange={e => setTelefoneDigitos(e.target.value.replace(/\D/g, '').slice(0, telefonePais.digitos))}
                style={{ ...inputStyle, flex: 1 }} />
            </div>
          </div>

          {/* CEP */}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ ...labelStyle, color: '#aeaeae' }}>CEP <span style={{ color: '#e24b4a' }}>*</span></label>
            <div style={{ position: 'relative' }}>
              <input type="text" inputMode="numeric" placeholder="00000-000" value={cep}
                onChange={e => buscarCep(e.target.value)} maxLength={9} style={inputStyle} />
              {cepCarregando && <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', fontSize: '11px', color: '#7bc47b' }}>buscando...</span>}
            </div>
          </div>

          {/* Rua + Número */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: '8px', marginBottom: '12px' }}>
            <div>
              <label style={{ ...labelStyle, color: '#aeaeae' }}>Rua / Avenida <span style={{ color: '#e24b4a' }}>*</span></label>
              <input type="text" placeholder="Nome da rua" value={rua} onChange={e => setRua(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={{ ...labelStyle, color: '#aeaeae' }}>Nº <span style={{ color: '#e24b4a' }}>*</span></label>
              <input type="text" placeholder="Nº" value={numero} onChange={e => setNumero(e.target.value)} style={inputStyle} />
            </div>
          </div>

          {/* Complemento */}
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Complemento</label>
            <input type="text" placeholder="Sala, andar, loja..." value={complemento} onChange={e => setComplemento(e.target.value)} style={inputStyle} />
          </div>

          {/* Bairro */}
          <div style={{ marginBottom: '12px' }}>
            <label style={{ ...labelStyle, color: '#aeaeae' }}>Bairro <span style={{ color: '#e24b4a' }}>*</span></label>
            <input type="text" placeholder="Nome do bairro" value={bairro} onChange={e => setBairro(e.target.value)} style={inputStyle} />
          </div>

          {/* Cidade + UF */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 70px', gap: '8px', marginBottom: '12px' }}>
            <div>
              <label style={{ ...labelStyle, color: '#aeaeae' }}>Cidade <span style={{ color: '#e24b4a' }}>*</span></label>
              <input type="text" placeholder="Sua cidade" value={cidade} onChange={e => setCidade(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={{ ...labelStyle, color: '#aeaeae' }}>UF <span style={{ color: '#e24b4a' }}>*</span></label>
              <input type="text" placeholder="RS" maxLength={2} value={estado} onChange={e => setEstado(e.target.value.toUpperCase())} style={inputStyle} />
            </div>
          </div>

          {/* Preview do endereço */}
          {rua && numero && bairro && cidade && (
            <div style={{ backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '10px', padding: '12px', marginBottom: '12px' }}>
              <div style={{ fontSize: '10px', color: '#7bc47b', marginBottom: '4px', letterSpacing: '1px', textTransform: 'uppercase' }}>Como vai aparecer</div>
              <div style={{ fontSize: '12px', color: '#ccc', lineHeight: '1.6' }}>
                {rua}, {numero}{complemento ? ` ${complemento}` : ''} — {bairro}<br />
                {cidade} - {estado}{cep ? `, CEP ${cep}` : ''}
              </div>
            </div>
          )}
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Descrição ({descricao.length}/120)</label>
            <textarea
              value={descricao}
              onChange={e => { if (e.target.value.length <= 120) setDescricao(e.target.value); }}
              placeholder="Uma breve descrição da sua barbearia..."
              rows={3}
              style={{ ...inputStyle, resize: 'none', lineHeight: '1.5' }}
            />
          </div>
        </>
      )}

      {/* ── PASSO 2: Barbeiros ── */}
      {passo === 2 && (
        <>
          <p style={{ fontSize: '12px', color: '#8f8f8f', marginBottom: '16px', lineHeight: '1.6' }}>
            Cadastre os barbeiros e seus horários. O último horário de cada turno ainda será atendido.
          </p>
          {barbeiros.map((b, i) => (
            <div key={i} style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '12px', padding: '12px', marginBottom: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <span style={{ fontSize: '12px', color: '#7bc47b', fontWeight: '600' }}>Barbeiro {i + 1}</span>
                {barbeiros.length > 1 && (
                  <span onClick={() => setBarbeiros(prev => prev.filter((_, idx) => idx !== i))}
                    style={{ fontSize: '18px', color: '#e24b4a', cursor: 'pointer' }}>×</span>
                )}
              </div>

              {/* Foto + Nome */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                <FotoAvatar fotoUrl={b.foto} onArquivo={arquivo => handleFotoBarbeiro(arquivo, i)} tamanho={56} redondo={true} />
                <div style={{ flex: 1 }}>
                  <label style={labelStyle}>Nome</label>
                  <input type="text" value={b.nome || ''} placeholder="Nome do barbeiro"
                    onChange={e => { const novos = [...barbeiros]; novos[i] = { ...novos[i], nome: e.target.value }; setBarbeiros(novos); }}
                    style={inputStyle} />
                </div>
              </div>

              {/* Toggle ocultar */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px', padding: '8px 10px', backgroundColor: '#111', borderRadius: '8px', border: '0.5px solid #252525' }}>
                <div>
                  <div style={{ fontSize: '12px', color: '#ccc', fontWeight: '500' }}>Ocultar barbeiro</div>
                  <div style={{ fontSize: '10px', color: '#8f8f8f', marginTop: '2px' }}>Não aparece para novos clientes</div>
                </div>
                <div
                  onClick={() => { const novos = [...barbeiros]; novos[i] = { ...novos[i], oculto: !novos[i].oculto }; setBarbeiros(novos); }}
                  style={{
                    width: '40px', height: '22px', borderRadius: '11px',
                    backgroundColor: barbeiros[i].oculto ? '#4a2d2d' : '#2d4a2d',
                    border: `1.5px solid ${barbeiros[i].oculto ? '#6a3d3d' : '#3d6b3d'}`,
                    position: 'relative', cursor: 'pointer', transition: 'background 0.2s', flexShrink: 0
                  }}>
                  <div style={{
                    position: 'absolute', top: '2px',
                    left: barbeiros[i].oculto ? '18px' : '2px',
                    width: '14px', height: '14px', borderRadius: '50%',
                    backgroundColor: barbeiros[i].oculto ? '#e24b4a' : '#7bc47b',
                    transition: 'left 0.2s'
                  }} />
                </div>
              </div>

              {/* Dias */}
              <div style={{ marginBottom: '8px' }}>
                <label style={labelStyle}>Dias de trabalho</label>
                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                  {DIAS_SEMANA.map(dia => {
                    const hp = b.horariosPorDia || {};
                    const ativo = hp[dia]?.length > 0;
                    const editando = getDiaEditando(i) === dia;
                    return (
                      <button key={dia} onClick={() => selecionarDiaBarb(i, dia)} style={{
                        padding: '5px 9px', borderRadius: '6px', fontSize: '11px', fontWeight: '600',
                        backgroundColor: editando ? '#3d6b3d' : ativo ? '#2d4a2d' : '#111',
                        color: ativo ? '#7bc47b' : '#555',
                        border: `0.5px solid ${editando ? '#5a9a5a' : ativo ? '#3d6b3d' : '#252525'}`,
                        cursor: 'pointer', fontFamily: 'Arial, sans-serif'
                      }}>{dia}</button>
                    );
                  })}
                </div>
              </div>

              {/* Editor de turnos */}
              {(() => {
                const diaEd = getDiaEditando(i);
                if (!diaEd) return null;
                const hp = b.horariosPorDia || {};
                const periodos = hp[diaEd] || [];
                const errTurnos = validarTurnos(periodos);
                const selectStyle = { ...inputStyle, fontSize: '12px', cursor: 'pointer', padding: '8px 10px', colorScheme: 'dark' };

                return (
                  <div style={{ backgroundColor: '#111', borderRadius: '8px', padding: '10px', marginBottom: '6px', border: `0.5px solid ${errTurnos ? '#4a1a1a' : '#2d4a2d'}` }}>
                    <div style={{ fontSize: '10px', color: '#7bc47b', fontWeight: '700', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '10px' }}>
                      {diaEd}
                    </div>

                    {periodos.map((p, pi) => (
                      <div key={pi} style={{ marginBottom: '10px' }}>
                        <div style={{ fontSize: '10px', color: '#8f8f8f', marginBottom: '5px', fontWeight: '600' }}>
                          {pi === 0 ? 'TURNO 1 — MANHÃ' : 'TURNO 2 — TARDE'}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '9px', color: '#7d7d7d', marginBottom: '3px' }}>Início</div>
                            <select value={p.inicio} onChange={e => updatePeriodoBarb(i, pi, 'inicio', e.target.value)} style={{ ...selectStyle, width: '100%' }}>
                              {HORARIOS_CONFIG.map(h => <option key={h} value={h}>{h}</option>)}
                            </select>
                          </div>
                          <span style={{ color: '#7d7d7d', fontSize: '14px', flexShrink: 0, marginTop: '12px' }}>→</span>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '9px', color: '#7d7d7d', marginBottom: '3px' }}>Último horário</div>
                            <select value={p.fim} onChange={e => updatePeriodoBarb(i, pi, 'fim', e.target.value)} style={{ ...selectStyle, width: '100%' }}>
                              {HORARIOS_CONFIG.map(h => <option key={h} value={h}>{h}</option>)}
                            </select>
                          </div>
                          {pi === 1 && (
                            <span onClick={() => removerTurno2(i)} style={{ color: '#e05555', cursor: 'pointer', fontSize: '18px', marginTop: '12px', flexShrink: 0 }}>×</span>
                          )}
                        </div>
                        <div style={{ fontSize: '10px', color: '#8f8f8f', marginTop: '4px' }}>
                          ⓘ Atende até <span style={{ color: '#7bc47b' }}>{p.fim}</span> — sai após o serviço das {p.fim}
                        </div>
                      </div>
                    ))}

                    {errTurnos && (
                      <p style={{ fontSize: '11px', color: '#e24b4a', marginBottom: '6px' }}>{errTurnos}</p>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px', paddingTop: '6px', borderTop: '0.5px solid #1a1a1a' }}>
                      {periodos.length < 2 ? (
                        <span onClick={() => adicionarTurno2(i)} style={{ fontSize: '11px', color: '#7bc47b', cursor: 'pointer' }}>+ Adicionar Turno 2</span>
                      ) : (
                        <span />
                      )}
                      <span onClick={() => removerDiaBarb(i, diaEd)} style={{ fontSize: '11px', color: '#8f8f8f', cursor: 'pointer', textDecoration: 'underline' }}>Remover {diaEd}</span>
                    </div>
                  </div>
                );
              })()}

              {/* Preview */}
              {Object.keys(b.horariosPorDia || {}).length > 0 && (
                <div style={{ backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '8px', padding: '8px 10px' }}>
                  {DIAS_SEMANA.filter(d => b.horariosPorDia?.[d]?.length > 0).map(d => (
                    <div key={d} style={{ display: 'flex', gap: '6px', fontSize: '11px', color: '#7bc47b', marginBottom: '2px' }}>
                      <span style={{ minWidth: '28px', fontWeight: '600' }}>{d}</span>
                      <span style={{ color: '#8f8f8f' }}>
                        {(b.horariosPorDia[d] || []).map((p, pi) => `T${pi + 1}: ${p.inicio}–${p.fim}`).join('  ·  ')}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}

          {barbeiros.length < 10 && (
            <button onClick={() => setBarbeiros(prev => [...prev, { ...BARBEIRO_PADRAO, nome: '', foto: '', horariosPorDia: JSON.parse(JSON.stringify(BARBEIRO_PADRAO.horariosPorDia)) }])} style={{
              width: '100%', backgroundColor: 'transparent', color: '#7bc47b',
              border: '0.5px dashed #2d4a2d', borderRadius: '10px', padding: '10px',
              cursor: 'pointer', fontSize: '12px', fontFamily: 'Arial, sans-serif', marginBottom: '8px'
            }}>+ Adicionar barbeiro</button>
          )}
        </>
      )}

      {/* ── PASSO 3: Serviços ── */}
      {passo === 3 && (
        <>
          <p style={{ fontSize: '12px', color: '#8f8f8f', marginBottom: '16px' }}>
            Cadastre os serviços oferecidos pela barbearia.
          </p>
          {servicos.map((s, i) => (
            <div key={i} style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '12px', padding: '12px', marginBottom: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ fontSize: '12px', color: '#7bc47b', fontWeight: '600' }}>Serviço {i + 1}</span>
                {servicos.length > 1 && (
                  <span onClick={() => setServicos(prev => prev.filter((_, idx) => idx !== i))}
                    style={{ fontSize: '18px', color: '#e24b4a', cursor: 'pointer' }}>×</span>
                )}
              </div>
              <div style={{ marginBottom: '8px' }}>
                <label style={labelStyle}>Nome do serviço</label>
                <input type="text" value={s.nome || ''} placeholder="Ex: Corte + Barba"
                  onChange={e => { const n = [...servicos]; n[i] = { ...n[i], nome: e.target.value }; setServicos(n); }}
                  style={inputStyle} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                <div>
                  <label style={labelStyle}>Preço</label>
                  <input type="text" inputMode="decimal" value={s.preco || ''} placeholder="R$ 0,00"
                    onChange={e => handlePrecoChange(i, e.target.value.replace(/^R\$\s?/, ''))}
                    style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Duração</label>
                  <select value={s.duracao || '30 min'}
                    onChange={e => { const n = [...servicos]; n[i] = { ...n[i], duracao: e.target.value }; setServicos(n); }}
                    style={{ ...inputStyle, cursor: 'pointer', colorScheme: 'dark' }}>
                    {duracoes.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
              </div>
            </div>
          ))}
          {servicos.length < 15 && (
            <button onClick={() => setServicos(prev => [...prev, { nome: '', preco: '', duracao: '30 min' }])} style={{
              width: '100%', backgroundColor: 'transparent', color: '#7bc47b',
              border: '0.5px dashed #2d4a2d', borderRadius: '10px', padding: '10px',
              cursor: 'pointer', fontSize: '12px', fontFamily: 'Arial, sans-serif', marginBottom: '8px'
            }}>+ Adicionar serviço</button>
          )}
        </>
      )}

      {/* ── PASSO 4: Fotos ── */}
      {passo === 4 && (
        <>
          <p style={{ fontSize: '12px', color: '#8f8f8f', marginBottom: '14px' }}>
            Fotos do recinto que aparecem para os clientes. (Opcional)
          </p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px', marginBottom: '14px' }}>
            {fotosRecinto.map((url, i) => (
              <div key={i} style={{ position: 'relative' }}>
                <img src={url} alt={`recinto ${i}`}
                  style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: '8px' }}
                  onError={e => e.target.style.display = 'none'} />
                <div onClick={() => setFotosRecinto(prev => prev.filter((_, idx) => idx !== i))}
                  style={{
                    position: 'absolute', top: 4, right: 4, width: '20px', height: '20px',
                    borderRadius: '50%', backgroundColor: 'rgba(0,0,0,0.7)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '12px', cursor: 'pointer', color: '#e24b4a'
                  }}>×</div>
              </div>
            ))}
          </div>
          {fotosRecinto.length < 8 && (
            <button onClick={() => setMenuRecintoAberto(true)} style={{
              width: '100%', backgroundColor: 'transparent', color: '#7bc47b',
              border: '0.5px dashed #2d4a2d', borderRadius: '10px', padding: '12px',
              cursor: 'pointer', fontSize: '12px', fontFamily: 'Arial, sans-serif', marginBottom: '16px'
            }}>+ Adicionar foto do recinto</button>
          )}
        </>
      )}

      {/* Feedback */}
      {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '8px' }}>{erro}</p>}
      {sucesso && (
        <div style={{ backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d', borderRadius: '10px', padding: '12px', marginBottom: '8px' }}>
          <p style={{ fontSize: '13px', color: '#7bc47b', margin: 0 }}>{sucesso}</p>
        </div>
      )}

      {/* Navegação entre passos */}
      <div style={{ display: 'flex', gap: '10px', marginTop: '16px' }}>
        {passo > 1 && (
          <button onClick={voltar} style={{
            flex: 1, backgroundColor: 'transparent', color: '#8f8f8f',
            border: '0.5px solid #252525', borderRadius: '12px', padding: '14px',
            fontSize: '14px', cursor: 'pointer', fontFamily: 'Arial, sans-serif'
          }}>← Anterior</button>
        )}
        <button onClick={avancar} disabled={salvando} style={{
          flex: 2, backgroundColor: salvando ? '#1a2a1a' : '#2d4a2d',
          color: '#7bc47b', border: 'none', borderRadius: '12px', padding: '14px',
          fontSize: '14px', fontWeight: '600', cursor: salvando ? 'default' : 'pointer',
          fontFamily: 'Arial, sans-serif'
        }}>
          {salvando ? 'Salvando...' : passo === TOTAL_PASSOS ? 'Salvar perfil' : 'Próximo →'}
        </button>
      </div>
    </div>
  );
}

export default PerfilBarbearia;
